'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import links from 'hub-pickers-lib/utils/links';
export const getRootUrl = () => '/myaccounts-beta';
export const getNextRedirectUrl = query => {
  if (!query) {
    return undefined;
  }

  if (query.next && links[query.next]) {
    return links[query.next];
  }

  return undefined;
};
/**
 * Gets the query params attached to the redirect url. If the passed query
 * params contains 'next', the param is removed from the list. This is to
 * prevent sending the next param when redirecting
 */

export const getRedirectQuery = query => {
  if (query.next) {
    // Deep copy query to avoid overwriting location.query
    const rest = _objectWithoutPropertiesLoose(query, ["next"]);

    return rest;
  }

  return query;
}; // OR, if you require portalID:
// export const getRootUrl = () => `${getBaseUrl()}/${PortalIdParser.get()}`;